/**
 * Handles the filling of the MPAN/MPRN fields
 * from the selected address
 * @module embed/pre_fill_from_address
 */

import { delegate } from '@/lib/events';
import { selectedOption } from '@/lib/forms';
import { SELECTOR_ADDRESS_SUPPLY } from './address';

const SELECTOR = '.js-pre-fill-from-address';
const SELECTOR_CURRENT_ADDRESS =
  '[name$="[addresses_attributes][present_attributes][known_address]"]';

const ATTR_VALUE_NAME = 'data-pre-fill-value';

/**
 * @param {HTMLElement} scope The form on which to listen to the events
 * @param {HTMLElement} el The element to pre-fill with the selected address
 */
function setupPrefill(scope, el) {
  const valueAttribute = `data-${el.getAttribute(ATTR_VALUE_NAME)}`;

  // Pre-fills the fields upon selection from the current address
  scope.addEventListener(
    'change',
    delegate(SELECTOR_CURRENT_ADDRESS, ({ target }) => {
      const option = selectedOption(target);
      if (option) {
        const value = option.getAttribute(valueAttribute);
        const previousValue = el.value;
        el.value = value;
        if (value != previousValue) {
          const event = new CustomEvent('change', { bubbles: true });
          el.dispatchEvent(event);
        }
      }
    })
  );

  // Clears the field if the user swaps to using manual inputs
  scope.addEventListener(
    'didShowAddressInput',
    delegate(SELECTOR_ADDRESS_SUPPLY, () => {
      const previousValue = el.value;
      el.value = '';
      if ('' != previousValue) {
        const event = new CustomEvent('change', { bubbles: true });
        el.dispatchEvent(event);
      }
    })
  );
}

export default function setupPrefillFromAddress(el) {
  Array.from(el.querySelectorAll(SELECTOR)).forEach(widget => {
    setupPrefill(el, widget);
  });
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/pre_fill_from_address.js